import { Controller } from "@hotwired/stimulus";
import flash from "../lib/flashes.js";

export default class extends Controller {
  static targets = ["hiddenInput", "selectionMode", "addMode", "newItemInput"];
  
  static values = {
    newListItemUrl: String,
    multipleOptions: Boolean
  };

  connect() {
    this.isAdd = false;
    this.selectElement = this.element.querySelector('select');
    this.tomSelectInstance = null;
    this.initializeSelectIntegration();
  }

  initializeSelectIntegration() {
    setTimeout(() => {
      if (this.selectElement && this.selectElement.tomselect) {
        this.tomSelectInstance = this.selectElement.tomselect;
        this.tomSelectInstance.on('change', () => {
          this.updateHiddenValue();
        });
        this.updateHiddenValue();
      } else {
        this.initializeSelectIntegration();
      }
    }, 100);
  }

  switchToAddMode(event) {
    event.preventDefault();
    this.isAdd = true;
    this.selectionModeTarget.classList.add('hidden');
    this.addModeTarget.classList.remove('hidden');
    this.newItemInputTarget.focus();
  }

  switchToSelectionMode() {
    this.isAdd = false;
    this.addModeTarget.classList.add('hidden');
    this.selectionModeTarget.classList.remove('hidden');
    this.newItemInputTarget.value = "";
  }

  // Bound to keydown, not keyup: the browser's implicit form submission fires
  // on Enter's keydown, so a keyup handler runs after the asset form has
  // already submitted and its preventDefault is too late.
  addItem(event) {
    event.preventDefault();
    const newItemName = this.newItemInputTarget.value.trim();
    if (!newItemName) return;

    fetch(this.newListItemUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ list_item: newItemName })
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        return response.json().then(data => Promise.reject(data));
      }
    })
    .then(data => {
      if (data.list_item) {
        this.tomSelectInstance.addOption({
          id: data.list_item.id,
          name: data.list_item.name
        });
        if (this.multipleOptionsValue) {
          this.tomSelectInstance.addItem(data.list_item.id);
        } else {
          this.tomSelectInstance.setValue(data.list_item.id);
        }
        this.updateHiddenValue();
        this.switchToSelectionMode();
      }
    })
    .catch(error => {
      console.error('Error adding item:', error);
      if (error && error[0]) {
        flash(error[0], 'error');
      } else {
        flash('Error adding item. Please try again.', 'error');
      }
      this.switchToSelectionMode();
    });
  }

  updateHiddenValue() {
    if (!this.tomSelectInstance) return;
    const selectedValues = this.tomSelectInstance.getValue();
    let returnArray = [];
    if (this.multipleOptionsValue) {
      if (Array.isArray(selectedValues)) {
        returnArray = selectedValues.map(id => parseInt(id));
      }
    } else {
      if (selectedValues) {
        returnArray = [parseInt(selectedValues)];
      }
    }
    const jsonValue = JSON.stringify({ "list_ids": returnArray });
    this.hiddenInputTarget.value = jsonValue;
  } 
}
